import React from "react";
import SubPageTemplate from "../../components/subpagetemplate";
import { useCategoryOffers } from "../../hooks/useCategoryOffers";
import HelmetSeo from "../../components/HelmetSeo";
import { pageSeoConfig } from "../../config/pageSeo";

const Computers: React.FC = () => {
  const computersData = useCategoryOffers("computers");
  const seoMeta = pageSeoConfig.computers;

  return (
    <>
      <HelmetSeo title={seoMeta.title} description={seoMeta.description} />
      <SubPageTemplate standard_categories={computersData} title="Computers" />
    </>
  );
};

export default Computers;
